















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'

@Component
export default class ComponentModalBackofficeAssinaturaMedico extends Vue {
  get getBackofficeCadastroMedicoStore() {
    return getModule(BackofficeCadastroMedicoStore, this.$store)
  }

  get showModalAssinaturaMedico() {
    return this.getBackofficeCadastroMedicoStore.modal.assinaturaMedico
  }

  set showModalAssinaturaMedico(value: boolean) {
    this.getBackofficeCadastroMedicoStore.setModal({ name: 'assinaturaMedico', value })
  }

  @Watch('showModalAssinaturaMedico')
  onChangeshowModalAssinaturaMedico(value: boolean) {
    if (!value) {
      this.getBackofficeCadastroMedicoStore.setAssinatura('')
    }
  }
}
